export interface PetGuardian {
  name: string;
  guardian_id: string;
  full_name: string;
  guardian_image: string;
  phone?: string | null;
  customer_id?: string | null;
  pet_id: string;
  pet_name: string;
  pet_image: string;
  status: string;
  creation: string;
}
import { GetAttachment } from "../attachment"
export interface AddEditPet {
  name?: string,
  pet_name: string,
  animal_species: AnimalSpecies,
  animal_type: AnimalType,
  breed: string,
  birth_date: Date | string,
  registration_date: Date | string,
  description?: string,
  image: string,
  color: string,
  gender: AnimalGender,
  weight: string | number,
  hight: string | number,
  blood_type: BloodType,
  play?: string,
  activity_exercise: string,
  status: PetStatus,
  food_type: string,
  food_brand: string
}
export interface Pet {
  name?: string | number,
  pet_name: string,
  animal_species: AnimalSpecies,
  animal_type: AnimalType,
  breed: string,
  birth_date: Date | string,
  registration_date: Date | string,
  description?: string,
  note?: string,
  pet_image: string | null,
  image?: string,
  color: string,
  gender: AnimalGender,
  weight: string | number,
  hight: string | number,
  blood_type: BloodType,
  play?: string,
  activity_exercise: string,
  status: PetStatus,
  food_type: string,
  type_name: string,
  food_brand: string,
  brand_name: string,
  images?: GetAttachment[]
}
export enum AnimalSpecies {
  Mammal="Mammal",
  Bird="Bird",
  Reptile="Reptile",
  Amphibian="Amphibian",
  Fish="Fish",
  Insect="Insect",
  Arachnid="Arachnid",
  Crustacean="Crustacean"
}
export enum AnimalType {
  Dog="Dog",
  Cat="Cat",
  Bird="Bird",
  Fish="Fish",
  Reptile="Reptile",
  Horse="Horse",
  Rabbit="Rabbit",
  Other="Other",
}
export enum AnimalGender {
  Male="Male",
  Female="Female",
  Unknown="Unknown"
}
export enum BloodType {
  APositive = 'A+',
  ANegative = 'A-',
  BPositive = 'B+',
  BNegative = 'B-',
  ABPositive = 'AB+',
  ABNegative = 'AB-',
  OPositive = 'O+',
  ONegative = 'O-',
}
export enum PetStatus {
  Available="Available",
  Adopted="Adopted",
  Fostered="Fostered",
  Missing="Missing",
  Found="Found",
  Deceased="Deceased",
  UnderTreatment="UnderTreatment",
  Reserved="Reserved"
}

export enum PetPlayLocation {
  Home = "Home",
  OutsideHome = "Outside Home",
  Garden = "Garden",
  Park = "Park",
  Clinic = "Clinic",
  Daycare = "Daycare",
  TrainingCenter = "Training Center",
  Beach = "Beach",
  Farm = "Farm",
  PetHotel = "Pet Hotel",
  Other = "Other",
}

export const AnimalSpeciesIcons: Record<AnimalSpecies, string> = {
  [AnimalSpecies.Mammal]: 'tabler-paw',
  [AnimalSpecies.Bird]: 'tabler-feather', // tabler-bird not in bundle
  [AnimalSpecies.Reptile]: 'tabler-paw', // tabler-snake not in bundle
  [AnimalSpecies.Amphibian]: 'tabler-frog',
  [AnimalSpecies.Fish]: 'tabler-fish',
  [AnimalSpecies.Insect]: 'tabler-bug',
  [AnimalSpecies.Arachnid]: 'tabler-spider',
  [AnimalSpecies.Crustacean]: 'tabler-crab',
}

export const AnimalTypeIcons: Record<AnimalType, string> = {
  [AnimalType.Dog]: 'tabler-dog',
  [AnimalType.Cat]: 'tabler-cat',
  [AnimalType.Bird]: 'tabler-feather', // tabler-bird is NOT in the icons.css bundle
  [AnimalType.Fish]: 'tabler-fish',
  [AnimalType.Reptile]: 'tabler-paw', // tabler-snake is NOT in the icons.css bundle
  [AnimalType.Horse]: 'tabler-horse',
  [AnimalType.Rabbit]: 'tabler-paw', // tabler-rabbit is NOT in the icons.css bundle
  [AnimalType.Other]: 'tabler-paw',
}

export interface PetDropDown{
pet_id:string,
pet_name:string,
pet_image:string|null,
animal_type?: string | null,
animal_species?: string | null,
weight?: number | string | null,
}
